import axios from 'axios';
import { generateUrl, getAccessToken, redirectPermission } from '../helper';
const MockInterview = axios.create({
    baseURL: generateUrl('mock-interview-dev2'),
});

MockInterview.interceptors.request.use(
    function (config) {
        let token = getAccessToken;
        if (token && token !== null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

MockInterview.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        if (error.response.status === 403) redirectPermission();
        return Promise.reject(error);
    }
);

export default MockInterview;
